import { useAppSelector } from 'app/store/store.hooks';

const useIsSeller = () => {
  const auth = useAppSelector((state) => state.auth.auth);

  return { isSeller: auth?.access.isSeller };
};

export const AuthHooks = {
  useIsSeller,
};
